module.exports = __webpack_public_path__ + "static/r32-628dcc08251cbd9452d050357fdd06fa.jpg";